var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-zoom",class:{ 'img-zoom--mobile': _vm.isMobile },style:({
    backgroundImage: `url(\'${
      _vm.src || _vm.$options.filters.image_by_id(_vm.head_img, _vm.$store.state, { width: _vm.width, height: _vm.height, quality: _vm.quality })
    }\')`,
  }),on:{"mousemove":_vm.zoom}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }